import Schedule from './Schedule.i18n';

export default Schedule
export { Schedule as Base }